/* eslint-disable no-console */

import { register } from 'register-service-worker';

if (process.env.NODE_ENV === 'production') {
	register(`${process.env.BASE_URL}service-worker.js`, {
		registrationOptions: {
			scope: process.env.BASE_URL,
		},
		ready() {
			console.warn('App is being served from cache by a service worker.\n For more details, visit https://goo.gl/AFskqB');
		},
		registered() {
			console.warn('Service worker has been registered.');
		},
		cached() {
			console.warn('Content has been cached for offline use.');
		},
		updatefound() {
			console.warn('New content is downloading.');
		},
		updated() {
			console.warn('New content is available; please refresh.');
		},
		offline() {
			console.warn('No internet connection found. App is running in offline mode.');
		},
		error(error) {
			console.error('Error during service worker registration:', error);
		},
	});
}
